import { ContextService } from '../../services/context_service';
import { DatenauswertungCO2FussabdruckDetails } from './DatenauswertungCO2FussabdruckDetails';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungVsme } from './DatenauswertungVsme';
import { Document, Font, Page, pdf } from '@react-pdf/renderer';
import { getAnhang } from './vsme/report/getAnhang';
import { getDeckblatt, getDeckblattBack } from './vsme/report/getDeckblatt';
import { getFooter } from './vsme/report/getFooter';
import { getHeader } from './vsme/report/getHeader';
import { getKatalog } from './vsme/report/getKatalog';
import { getStyle } from './vsme/report/getStyle';
import { getVSMEText } from '../../main/functions/vsme/getVSMEText';
import { getVorwort } from './vsme/report/getVorwort';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { Module } from './vsme/report/Module';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { SectionStyle } from '../../helpers/SectionStyle';
import style from '../datenauswertung/datenauswertung.less';

interface DatenauswertungVsmeReportProps extends React.ClassAttributes<any> {
    data: any;
    routing: any;
    standortTid: number;
    standortName: string;
    onRoutingChange: (routing: any) => void;
    jahr?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungVsmeReportState {
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    showSpinner: boolean;
    pdfString?: string;
    jsxB3Co2: JSX.Element;
    jsxAnhangAuswertung: JSX.Element
}

export class DatenauswertungVsmeReport extends React.Component<DatenauswertungVsmeReportProps, DatenauswertungVsmeReportState> {

    constructor(props: any) {
        super(props);
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;

        this.state = {
            jahr: this.props.jahr || jahrMax - 1,
            jahrMax,
            jahrMin,
            showSpinner: false,
            jsxB3Co2: null,
            jsxAnhangAuswertung: null
        };

        this.setBookmark = this.setBookmark.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private bookmarks: any = {};
    private sectionColor: string;

    render(): JSX.Element {
        const { data, standortTid } = this.props;
        const { jahr } = this.state;
        return <>
            {!this.props.setJSXdirect && <>
                <div className={style.datenauswertungOuterFormContainer}>
                    <DatenauswertungJahrauswahlEinzeln
                        jahrMax={this.state.jahrMax}
                        jahrMin={this.state.jahrMin}
                        jahr={this.state.jahr}
                        externalHeaderElements={[this.renderEingabeButton(), this.renderPdfButton()]}
                        onJahrChange={(jahr: number) => this.setState({ jahr: +jahr, jsxAnhangAuswertung: null })}
                    />
                    {/*<div style={{ padding: 5, paddingRight: 20 }}>
                        {this.renderHelpIcon()}
                    </div>*/}
                </div>
                <div
                    style={{
                        maxWidth: 720, padding: '3px 0 3px 16px', display: 'flex', flex: 1, flexDirection: 'column', boxSizing: 'border-box'
                    }}
                >
                    <div style={{ fontSize: '16pt', fontWeight: 'bold', textAlign: 'center', color: this.sectionColor, marginTop: '12pt' }}>
                        Vorschau
                    </div>
                    {getVorwort(false, null, data, jahr, standortTid)}
                    <Module
                        isPdf={false}
                        data={data}
                        jahr={jahr}
                        standortTid={standortTid}
                        jsxB3Co2={this.renderB3Co2()}
                    />
                    {/* <div>{this.renderB3Co2()}</div> */}
                    {/* <div>{this.renderAnhangAuswertung()}</div> */}
                    {getAnhang(false, [this.renderAnhangAuswertung()])}
                </div>
            </>}
            {this.state.showSpinner && <WSpinner label={'PDF...'} />}
       </>;
    }

    renderEingabeButton(): JSX.Element {
        const path: any = RoutingIDs.ROUTE_DATENEINGABE;
        return (
            <WActionButton
                styleProps={{ color: 'white', backgroundColor: this.sectionColor, padding: '1px 8px 1px 2px' }}
                label='Dateneingabe'
                insideText='Dateneingabe'
                tooltip='Zum Dateneingabebereich springen'
                key='dateneingabe'
                action='edit'
                onAction={() => this.props.onRoutingChange({ path })}
            />
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                styleProps={{ color: 'white', backgroundColor: this.sectionColor, padding: '1px 8px 1px 2px' }}
                label='Report erstellen'
                insideText='Report erstellen'
                key='pdf'
                action='pdf'
                onAction={() => this.makePDF()}
            />
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{
                    verticalAlign: 'top', color: 'white', backgroundColor: '#ed7d31', width: 18, height: 18, margin: 0, borderRadius: 10
                }}
                label='Report - Hinweise'
                helpKey='datenauswertung_vsme_report'
                type='info'
                editBar
            />
        );
    }

    async makePDF(catalogDone = false): Promise<void> {
        this.setState({ showSpinner: true });
        // const fontCalibri = require('../../font/calibri_regular.ttf');
        // const fontCalibriBold = require('../../font/calibri_bold.ttf');
        // Font.register({ family: 'Calibri', src: fontCalibri });
        // Font.register({ family: 'Calibri-Bold', src: fontCalibriBold });

        const { data, standortTid } = this.props;
        const { jahr, jsxB3Co2, jsxAnhangAuswertung } = this.state;
        const pageStyle = getStyle('page');
        const logoURL = this.contextService.get('UNTERNEHMEN_LOGO_URL');
        const unternehmen = getVSMEText('unternehmen', data, jahr, standortTid);
        const isPdf = true;
        const pdfData: JSX.Element = (
            <Document>
                <Page size='A4' orientation='portrait' style={{ padding: 0 }}>
                    {getDeckblatt(logoURL, unternehmen)}
                </Page>
                <Page size='A4' orientation='portrait' style={pageStyle}>
                    {getKatalog(this.bookmarks)}
                </Page>
                <Page size='A4' orientation='portrait' style={pageStyle}>
                    {getHeader(logoURL, unternehmen, jahr)}
                    {getFooter()}
                    {getVorwort(isPdf, this.setBookmark, data, jahr, standortTid)}
                    <Module
                        isPdf
                        data={data}
                        jahr={jahr}
                        standortTid={standortTid}
                        jsxB3Co2={jsxB3Co2}
                        getPageNum={this.setBookmark}
                    />
                </Page>
                <Page size='A4' orientation='portrait' style={pageStyle}>
                    {getHeader(logoURL, unternehmen, jahr)}
                    {getFooter()}
                    {getAnhang(isPdf, [jsxAnhangAuswertung], this.setBookmark)}
                </Page>
                <Page size='A4' orientation='portrait' style={{ padding: 0 }}>
                    {getDeckblattBack()}
                </Page>
            </Document>
        );

        try {
            // catalogDone === false -> 1. Round, um das Inhaltsverzeichnis zu erstellen.
            // catalogDone === true -> 2. Round, um PDF zu erstellen.
            const blob = await pdf(pdfData).toBlob();
            const filename = 'Datenauswertung_VSME_Report.pdf';
            if (catalogDone) {
                saveAs(blob, filename);
            } else {
                await this.makePDF(true);
            }
        } catch (error) {
            console.error(error);
        }

        this.setState({ showSpinner: false });
    }

    renderB3Co2(): JSX.Element {
        const { data, standortName, standortTid } = this.props;
        const { jahr } = this.state;
        return <DatenauswertungCO2FussabdruckDetails
            data={data}
            onRoutingChange={() => { }}
            routing={this.props.routing}
            standortTid={standortTid}
            standortName={standortName}
            jahr={jahr}
            chartOnly
            parentElement='EnergieCockpit'
            diagramStyle={{ height: 330 }}
            setJSXdirect={(jsxB3Co2: JSX.Element) => this.setState({ jsxB3Co2 })}
        />;
    }

    renderAnhangAuswertung(): JSX.Element {
        const { data, standortName, standortTid } = this.props;
        const { jahr } = this.state;
        return <DatenauswertungVsme
            data={data}
            onRoutingChange={() => { }}
            routing={this.props.routing}
            standortTid={standortTid}
            standortName={standortName}
            jahr={jahr}
            contentOnly
            setJSXdirect={(jsxAnhangAuswertung: JSX.Element) => {
                if (!this.state.jsxAnhangAuswertung) {
                    this.setState({ jsxAnhangAuswertung });
                }
            }}
        />;
    }

    setBookmark(key: string, page: number, level: number): void {
        this.bookmarks[key] = { page, level };
    }

    setColors(): void {
        this.sectionColor = (SectionStyle.getSectionColors() || {}).datenauswertung;
    }
}
